import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ec3061a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "prize-won-image" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "overlay"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "used-prize-coupon" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "賞品受取済")
  ])
], -1))
const _hoisted_5 = { class: "used-at" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", { src: _ctx.prizeWonImageUrl }, null, 8, _hoisted_2),
    (_ctx.hasUsedPrizeCoupon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _hoisted_4,
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.prizeCouponUsedAtString), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}